import { useState } from 'react';
import DOMPurify from 'dompurify';

export default function usePaymentRedirection() {
  const [redirectingToPaymentProvider, setRedirectingToPaymentProvider] =
    useState(false);

  const handlePaymentRedirection = (
    paymentUrl: string,
    onError: (errorMessage: string) => void
  ) => {
    setRedirectingToPaymentProvider(true);

    try {
      const sanitizedUrl = DOMPurify.sanitize(paymentUrl);
      window.open(sanitizedUrl, '_self', 'noopener,noreferrer');
    } catch (error) {
      console.error('Redirect validation failed:', error);
      setRedirectingToPaymentProvider(false);
      onError(
        'Invalid payment gateway URL. Please try again or contact support.'
      );
    }
  };

  return {
    redirectingToPaymentProvider,
    handlePaymentRedirection,
  };
}
